<template>
  <div class="row">
    <div class="col-md-12 text-center">
      <progress-gauge :progress="progress" />
    </div>
    <!-- <div class="col-md-4 text-center">{{ thumbsUp }}</div>
    <div class="col-md-3 text-center custom-tracked">
      <div class="custom-thumbs-up">
        {{ tracked }}<i class="fas fa-thumbs-up"></i>
      </div>
    </div> -->
  </div>
</template>
<script>
import moment from 'moment'
import globals from '@/Plugins/globals'
import ProgressGauge from './progress-gauge'
export default {
  name: 'food-progress',
  components: {
    ProgressGauge,
  },
  props: {
    row: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    // console.log('Food Progress', this.row)
  },
  computed: {
    progress() {
      let _progress = [0, 0, 0]
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.foodTracking !== undefined &&
          this.row.foodTracking !== null
        ) {
          _progress = []
          let total = parseFloat(this.row.foodTracking.foodTracked)
          let countUp = parseFloat(this.row.foodTracking.countThumbsUp)
          let countNeutral = parseFloat(this.row.foodTracking.countNeutral)
          let countDown = parseFloat(this.row.foodTracking.countThumbsDown)
          // if (this.row.foodTracking.length >= 1) {
          //   _progress = []
          //   this.row.foodTracking.forEach((element) => {
          //     total += element.count
          //     if (element.userRating === 1) {
          //       countUp += element.count
          //     } else if (element.userRating === -1) {
          //       countDown += element.count
          //     } else {
          //       countNeutral += element.count
          //     }
          //   })
          if (total > 0) {
            _progress.push(globals.roundUp((countDown / total) * 100, 1))
            _progress.push(globals.roundUp((countNeutral / total) * 100, 1))
            _progress.push(globals.roundUp((countUp / total) * 100, 1))
          }
          // }
        }
      }
      // console.log('Food Progress (listing)', {
      //   row: this.row.foodTracking,
      //   progress: _progress,
      // })
      return _progress
    },
    thumbsUp() {
      // total Thumbs Up percent
      let _data = 0
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.foodTracking !== undefined &&
          this.row.foodTracking !== null
        ) {
          let total = this.row.foodTracking.foodTracked
          let countUp = this.row.foodTracking.countThumbsUp
          // if (this.row.foodTracking.length >= 1) {
          //   this.row.foodTracking.forEach((element) => {
          //     total += element.count
          //     // thumbs up
          //     if (element.userRating === 1) {
          //       countUp += element.count
          //     }
          //   })
          // }
          _data = total > 0 ? globals.roundUp((countUp / total) * 100, 1) : 0
        }
      }
      // console.log('Thumbs Up (listing)', {
      //   row: this.row.foodTracking,
      //   data: _data,
      // })
      return _data
    },
    tracked() {
      // total food items with Thumbs Up
      let _data = 0
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.foodTracking !== undefined &&
          this.row.foodTracking !== null
        ) {
          _data = this.row.foodTracking.foodTracked
          // if (this.row.foodTracking.length > 1) {
          //   this.row.foodTracking.forEach((element) => {
          //     // thumbs up
          //     if (element.userRating === 1) {
          //       _data += element.count
          //     }
          //   })
          // }
        }
      }
      return _data
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-change-red {
  color: red;
  font-weight: 500;
}
.custom-tracked {
  position: relative;
}
.custom-thumbs-up {
  position: relative;
  i {
    font-size: 0.8em;
    position: relative;
    top: -8px;
    left: 5px;
    color: green;
  }
}
</style>
